import { Paginacion } from './paginacion';
export class FiltrosBandeja {
  public NroFormulario: string;
  public IdDepartamento: number;
  public IdProvincia: number;
  public IdConvocatoria: number;
  public IdTipoGrupo: number;
  public IdEstado: number;
  public NroDocumento: string;
  public Nombre: string;
  public ApellidoPaterno: string;
  public ApellidoMaterno: string;
  public FechaInicio: string;
  public FechaFin: string;
  public Paginacion: Paginacion;
  public TipoProceso: number;
    constructor(tipoProceso: number) {
      this.IdDepartamento = null;
      this.IdConvocatoria = null;
      this.IdTipoGrupo = null;
      this.IdEstado = null;
      this.TipoProceso = tipoProceso;
    }
}
